export enum GroupTemplateName {
  CUSTOMER_INVOICE_TEMPLATE = 'CustomerInvoiceTemplate',
  MERCHANT_INVOICE_TEMPLATE = 'MerchantInvoiceTemplate',
  REFUND_TEMPLATE = 'RefundTemplate',
  CUSTOMER_DELETE_TEMPLATE = 'CustomerDeleteTemplate',
  CUSTOMER_RESET_TEMPLATE = 'CustomerResetTemplate',
  CUSTOMER_EMAIL_VERIFICATION_TEMPLATE = 'CustomerEmailVerificationTemplate',
}
